import React from 'react';
import PropTypes from 'prop-types';
import { Form, Icon, Input } from 'antd';
import { autobind } from 'core-decorators';
import BaseComponent from 'components/BaseComponent';
import styledComp, { FlexRowContainer } from 'components/StyledComp';
import CustomButton from 'components/CustomButton';
import dataStorage from 'misc/data-storage';
import helpers from 'misc/helpers';

const propTypes = {
  form: PropTypes.object.isRequired,
};

@autobind
class LoginForm extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // Save where does the user come from.
    this.from = this.parseQueryParam('from', this.props.location);

    this.cellPhoneInput.focus();
  }

  async loginByUserName(userName, password) {
    try {
      const params = {
        userName,
        password,
      };
      const responseBody = await this.callService('/user/login2', params);

      // Save login result.
      dataStorage.saveCredential(...responseBody.getRetArray());

      // Notify login success.
      this.notifySuccess('Success', 'Login success, redirecting...');

      // Navigate to from or home page.
      setTimeout(() => {
        const dest = this.from?.startsWith('/') ? this.from : '/patients/patients?type=PROCESSING';
        window.location = dest;
      }, 2000);
    } catch (err) {
      // Remove the existing password in the form.
      this.props.form.setFieldsValue({
        password: '',
      });

      throw err; // Continue reject.
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.loginByUserName(
          helpers.extraFormInputValue(values, 'userName'),
          helpers.extraFormInputValue(values, 'password'),
        );
      }
    });
  }

  render() {
    const { form, ...layoutProps } = this.props;
    const { getFieldDecorator } = form;

    return (
      <styledComp.AntdForm
        {...layoutProps}
        onSubmit={this.handleSubmit}
      >
        <styledComp.AntdFormItem
          width="match_parent"
          height="wrap_content"
        >
          {getFieldDecorator('userName', {
            rules: [{
              required: true,
              message: 'Please enter your user name.',
            }, {
              max: 30,
              message: 'Username must be 4-30 characters long.',
            }],
          })(
            <Input
              ref={(input) => { this.cellPhoneInput = input; }}
              type="text"
              placeholder="Username"
              size="large"
            />,
          )}
        </styledComp.AntdFormItem>

        <styledComp.AntdFormItem
          width="match_parent"
          height="wrap_content"
        >
          {getFieldDecorator('password', {
            rules: [{
              required: true,
              message: 'Please enter your password.',
            }, {
              max: 120,
              message: 'Too long.',
            }],
          })(
            <Input
              type="password"
              placeholder="Password"
              size="large"
            />,
          )}
        </styledComp.AntdFormItem>

        <FlexRowContainer
          width="match_parent"
          height="wrap_content"
          justifyContent="space-between"
          alignItems="center"
        >
          <CustomButton
            width="match_parent"
            height="38px"
            backgroundColor="green_haze"
            fontSize="16px"
            type="primary"
            htmlType="submit"
          >
            LOGIN
            <Icon type="arrow-right" />
          </CustomButton>
        </FlexRowContainer>
      </styledComp.AntdForm>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
LoginForm.propTypes = propTypes;

export default Form.create({})(LoginForm);
